import axios from "axios";
import { getAccessTokenApi } from "./auth";

const basePath = localStorage.getItem('SERVERCENTRAL');


export function getTiposDocumentacionAdjudicacion( data ) {
    const url = `${basePath}/consultaTiposDocumentacion`;
    const jwt = getAccessTokenApi();
    return axios.post(url,  data ,{
      headers: { 
        "Authorization": jwt,
        'Content-Type': 'application/json',
        Accept: "application/json",
      }
    });
}

export function getArticulosAdjudicacion( data ) {
    const url = `${basePath}/consultaArticulosAdjudicacion`;
    const jwt = getAccessTokenApi();
    return axios.post(url,  data ,{
      headers: { 
        "Authorization": jwt,
        'Content-Type': 'application/json',
        Accept: "application/json",
      }
    });
}

export function enviaNotificacionAdjudicacion( data ) {
    const url = `${basePath}/enviaNotificacionAdjudicacion`;
    const jwt = getAccessTokenApi();
    return axios.post(url,  data ,{
      headers: { 
        "Authorization": jwt,
        'Content-Type': 'application/json',
        Accept: "application/json",
      }
    });
}

export function desactivaAdjudicacion( data ) {
    const url = `${basePath}/desactivaAdjudicacion`;
    const jwt = getAccessTokenApi();
    return axios.post(url,  data ,{
      headers: { 
        "Authorization": jwt,
        'Content-Type': 'application/json',
        Accept: "application/json",
      }
    });
}

export function procesaCargaMasivaAdjudicacion( data ) {
    const url = `${basePath}/procesaCargaMasivaAdjudicacion`;
    const jwt = getAccessTokenApi();
    return axios.post(url,  data ,{
      headers: { 
        "Authorization": jwt,
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      }
    });
}
